// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"5":"html2canvas","297":"pdfjs-dist","418":"tui-image-editor","458":"jspdf","669":"froala-editor","812":"croppie"}[chunkId] || chunkId) + ".min.js";
};